/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaCategoryModel } from "@nf/common";
import { useTranslation } from "next-i18next";

import Genres from "./Genres";

import styles from "./ChannelsSection.module.scss";

interface GenresSectionProps {
  genres: IMediaCategoryModel[];
}

const GenresSection = ({ genres }: GenresSectionProps) => {
  const { t } = useTranslation("translations");

  return (
    <>
      <h4 className={styles.title}>{t("web_search_genres")}</h4>
      <Genres genres={genres} />
    </>
  );
};

export default GenresSection;
